// ZB Featured Collection List
// Crossfades the background image matching the hovered/focused collection link.
// Reverts to the default (first) image when the pointer/focus leaves.

(function () {
  function initFeaturedCollectionList(root) {
    var images = root.querySelectorAll('.zb-fcl__img');
    var links = root.querySelectorAll('.zb-fcl__link');

    if (!images.length || !links.length) return;

    function setActive(index) {
      images.forEach(function (img) {
        img.classList.toggle('active', img.getAttribute('data-index') === String(index));
      });
      links.forEach(function (link) {
        link.classList.toggle('active', link.getAttribute('data-index') === String(index));
      });
    }

    function resetToDefault() {
      setActive(0);
    }

    links.forEach(function (link) {
      if (link.classList.contains('zb-fcl__link--disabled')) return;

      var index = link.getAttribute('data-index');

      link.addEventListener('mouseenter', function () {
        setActive(index);
      });

      link.addEventListener('focus', function () {
        setActive(index);
      });

      link.addEventListener('mouseleave', function () {
        resetToDefault();
      });

      link.addEventListener('blur', function () {
        resetToDefault();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.zb-fcl').forEach(initFeaturedCollectionList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify section editor re-renders this section
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-fcl');
    if (root) initFeaturedCollectionList(root);
  });
})();